import React, { Component } from 'react'
import http from 'src/helper/http'
import './index.less'
import langM from './lang.js'
import {
  setDocumentTitle,
  setUidToken,
  getlang,
  setlang,
  inject,
  observer,
} from '../../../helper/devTools.js'
import localstorage from 'src/helper/localstorage'
import config from 'src/core/config'
import {
  jumpToWallet,
  closeWebview,
} from 'src/helper/webviewFun'
import VConsole from 'src/helper/vconsole'
@inject('store')
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    // this.welfareStore = this.props.store.register('activity/welfare')
    setDocumentTitle('APP GAME')
  }
  state = {
    messageTxt: '',
    currentNum: 500,
    enoughTip: false,
    exchangeTip: false,
    popUpShow: false,
    uid: 0,
    accesstoken: '',
    typeStatus: 1,
    rankList: [],
    recordList: [],
    myRank: {},
    scrollParams: '0,30',
    hasMore: false,
    timeID: null,
    showTo:false,
    ruby:0,
    lang:langM.en,
    language:'en',
    link:"",
    type:1,
  }

  async initLang() {
    let { language } = this.props.location.query
    language = await getlang(language)
    this.setState({
      lang: setlang(language, langM),
      language: language
    })
    console.log('language', language)
  }

  async initUid() {
    let uid = await setUidToken(this.props.location.query)
    console.log(uid, 'uid')
    // if (uid == 1014694) {
    //   new VConsole()
    // }
    return uid
  }
   getNewRuby = async(uid)=> {
    let url = this.state.GameURL
    if (this.state.showTo == true) return
    let id = setInterval(async () => {
      let ruby = this.state.ruby
      let res = await http.post('/web/MyAccountInfo', { uid: uid  })//
      if (!this.state.showTo) {
        this.setState({
          showTo:true
        })
      }
      console.log(res.res.gold,'-----res.res.gold-----')
      if (res.code !== 0) return
      if (ruby == res.res.gold) return
      let iframe = document.getElementById('app-games-iframe-main')
      let iframeWindow = iframe.contentWindow // 利用iframe.contentWindow 也就是4.html 的window对象.
      let map = { msgtp: 'refresh', content: res.res.gold }
      // iframeWindow.postMessage(JSON.stringify(map),'http://localhost:8000') // 第二个参数,指定4.html的域名
      iframeWindow.postMessage(JSON.stringify(map), url) // 第二个参数,指定4.html的域名
      console.log(url)
      this.setState({ruby: res.res.gold})
    }, 5000)
    this.setState({
      timeID:id
    })
    setTimeout(() => {
      window.clearInterval(this.state.timeID)
      this.state.showTo = false
      this.setState({
        timeID: null
      })
    }, 60000)
  }
  async componentDidMount() {
    this.initLang()
    let uid = await this.initUid()
    await this.RunOnStart(uid)
    http.post('/web/MyAccountInfo', { uid: uid  }).then(res=>{
      res.code == 0 && this.setState({ruby:res.res.gold})
    })//
    window.addEventListener(
      'message',
       async(e)=> {
        if (e.data && e.data != '') {
          try {
            let d = JSON.parse(e.data)
            if (d.msgtp == 'popRecharge') {
              console.log('触发顶层逻辑--popRecharge', d.content,'popRecharge--水果机')
              this.state.timeID && clearInterval(this.state.timeID)
              await this.setState({showTo:false})
              await  this.getNewRuby(this.state.uid)
              jumpToWallet(0)
              return   
            }
            if (d.msgtp == 'popClose') return closeWebview()
           
          } catch (error) {
            console.error(error)
          }
        }
      },
      false
    )
  }



  // 初始化/接口请求初始化
  RunOnStart = async (uid) => {
    const { uid:lguid, accesstoken } = localstorage.get('userInfo')
    this.setState({
      uid: uid || lguid,
      accesstoken: accesstoken
    })
  }

  render() {
    let gameInfo =[
      {id:103,type:1,name:'龙虎斗-灵仙',testLink:'https://gztest.leadercc.com/chatie_games/dragon_tiger_half/index.html',plk:'https://d3vtcjbq0jctm3.cloudfront.net/games/dragon_tiger_half/index.html'},
      {id:105,type:1,name:'捕鱼-灵仙',testLink:'http://gztest.leadercc.com/chatie_games/fish4_half/index.html',plk:'https://d3vtcjbq0jctm3.cloudfront.net/games/fish4_half/index.html'},
      {id:101,type:1,name:'水果游戏-灵仙',testLink:'https://gztest.leadercc.com/chatie_games/fruit_turntable_half/index.html',plk:'https://d3vtcjbq0jctm3.cloudfront.net/games/fruit_turntable_half/index.html'},
      {id:206,type:2,name:'关羽砍刀-热游',testLink:'https://www.hotgame.win/box/chatie_test/half?gameID=206',plk:'https://cdn-web.hotgame.win/game/Box/half/?sdk=chatie&gameID=206'},
      {id:206,type:2,name:'水果游戏-热游',testLink:'https://www.hotgame.win/FruitSlots/chatie_test/half?gameID=202',plk:'https://cdn-web.hotgame.win/game/FruitSlots/half/?sdk=chatie&gameID=202'},
      {id:104,type:1,name:'跑车转盘-灵仙',testLink:'http://gztest.leadercc.com/chatie_games/speed_racing_half/index.html',plk:'https://d3vtcjbq0jctm3.cloudfront.net/games/speed_racing_half/index.html'},
      {id:106,type:1,name:'足球俱乐部-灵仙',testLink:'http://gztest.leadercc.com/chatie_games/wheel4_half/index.html',plk:'https://d3vtcjbq0jctm3.cloudfront.net/games/wheel4_half/index.html'},
      {id:107,type:1,name:'财神游戏-灵仙',testLink:'https://gztest.leadercc.com/chatie_games/super_rich_god_half/index.html',plk:'https://d3vtcjbq0jctm3.cloudfront.net/games/super_rich_god_half/index.html'},
      {id:108,type:1,name:'蔬菜转盘-灵仙',testLink:'https://gztest.leadercc.com/chatie_games/wheel_half/index.html',plk:'https://d3vtcjbq0jctm3.cloudfront.net/games/wheel_half/index.html'},
      {id:1153877559,type:2,name:'摩天轮-热游',testLink:'https://www.hotgame.win/FerrisWheel/chatie_test/seven?gameID=1153877559',plk:'https://cdn-web.hotgame.win/game/GreedyStar/seven/?sdk=chatie&gameID=1153877559'},
      {id:102,type:1,name:'埃及游戏-灵仙',testLink:'https://gztest.leadercc.com/chatie_games/liberty_bell4_half/index.html',plk:'https://d3vtcjbq0jctm3.cloudfront.net/games/liberty_bell4_half/index.html'},
      {id:215,type:2,name:'足球slot-热游',testLink:'https://cdn-web.hotgame.win/game/FootballSlot/half/?sdk=chatie&gameID=215&game_env=dev',plk:'https://cdn-web.hotgame.win/game/FootballSlot/half/?sdk=chatie&gameID=215'},
      {id:201,type:1,name:'快乐轮盘 gameid 10-灵仙',testLink:'https://gztest.leadercc.com/chatie_games/zhuanpan2_medium/index.html',plk:'https://d3vtcjbq0jctm3.cloudfront.net/games/zhuanpan2_medium/index.html'},
      {id:96,type:1,name:'幸运77 灵仙',testLink:'https://gztest.leadercc.com/chatie_games/luck77_half/index.html',plk:'https://d3vtcjbq0jctm3.cloudfront.net/games/luck77_half/index.html'},
    ]
    let url = window.location.href.split('?')
    let abc = url[1].split('&')
    let prams = {}
    let link = ''
    for (const str of abc) {
      let [key, valuse] = str.split('=')
      prams[key] = valuse
      if (key == 'id') {
        prams = gameInfo.find(item=>item.id == valuse)
        if (config.host == "https://api-test.thechatie.com") {
            link = prams.testLink
        }else{
          link = prams.plk
        }
        continue
      }
    }
    console.log(`${link}${prams.type==2?'&':'?'}uid=${this.state.uid}&${prams.type==2?'accesstoken':'token'}=${this.state.accesstoken}&lang=${this.state.language == "zh" ? "en" : this.state.language}`)
    return (
      <div className={`game1`}>
        <iframe
          className="app-games-iframe"
          id="app-games-iframe-main"
          src={`${link}${prams.type==2?'&':'?'}uid=${this.state.uid}&${prams.type==2?'accesstoken':'token'}=${this.state.accesstoken}&lang=${this.state.language == "zh" ? "en" : this.state.language}`}
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        ></iframe>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/game-cofing/index.js